import axios from 'axios';

export const ProtectAPi = () => {
  const token = localStorage.getItem('token');

  const http = axios.create({
    baseURL: 'https://footbalancetech.com/footserver/api',
    //baseURL: 'http://127.0.0.1:8000/api',
    headers: {
      Accept: 'application/json',
      Authorization: token ? `Bearer ${token}` : ''
    }
  });

  return { http };
};

